export type { ImageSlots, ImageBaseProps as ImageProps, ImageBaseState as ImageState } from '@fluentui/react-image';
